import "./TransportSummary.css";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

import "../repeats/mainBtn/MainBtn.css";
import {
  addOrder,
  modifyLocalForm,
  resetOrder,
} from "../../redux/actions-exporter";

// bootstrap

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

//components
import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
import PaymentSuccess from "../repeats/paymentSuccess/PaymentSuccess";

//images
import bannerImg from "../../assets/images/TII/0d29cde6ea92435fc56819d5d1f3d55a.jpg";
import galleryImg1 from "../../assets/images/MT/6.jpg";
import galleryImg2 from "../../assets/images/MT/GettyImages-135385164_pczbmr.jpg";
import galleryImg3 from "../../assets/images/MT/moving-checklist-2000-6ec63f4c4aa94bf9b9cb32f80bfd97a7.jpg";
import galleryImg4 from "../../assets/images/MT/6-Common-Mistakes-to-Avoid-When-Hiring-a-Moving-Company.jpeg";
import galleryImg5 from "../../assets/images/MT/AdobeStock_300477109-min_a23ba322c2da1cd76ade9dd3d3983ed1_2000.jpeg";
import galleryImg6 from "../../assets/images/MT/movers-collegeville.jpg";
import logo from "../nav/Logo";

const TransportSummary = ({ mainLogo }) => {
  const SERVICES_CATEGORY_ID = process.env.REACT_APP_SERVICES_CATEGORY_ID;
  const BOXES_CATEGORY_ID = process.env.REACT_APP_BOXES_CATEGORY_ID;
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);

  const addedOrder = useSelector((state) => state.order.addedOrder);
  const x = useSelector((state) => state.order);
  const form = useSelector((state) => state.form);
  const cartFromLocalForm = useSelector((state) => state.form.cart);
  const products = useSelector(
    (state) => state.productCategories.productsCategoryById
  );
  const [cart, setCart] = useState(cartFromLocalForm);
  const [totalPrice, setTotalPrice] = useState(form.price);
  const [checked, setChecked] = useState(false);
  const [send, setSend] = useState(false);
  const [read, setRead] = useState(false);
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [packageService, setPackageService] = useState({})


  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView();
  //   setStart(false);
  // }, [start]);


  useEffect(() => {
    const boxes = products[BOXES_CATEGORY_ID];
    const boxIds = boxes.map((box) => box.entityId);
    let boxesInCart = form.cart.filter(
      (item) => boxIds.includes(item.entityId) && item.entityId !== 277130
    )
    if (boxesInCart.length) {
      let amountOfBoxes = boxesInCart.map(box => box.title.split(" ")[0].split('-')[1]).reduce((acc, n) => acc + +n, 0)
      let packageService = products[SERVICES_CATEGORY_ID].find(
        (element) => element.entityId === 277527
      );
      setPackageService({ ...packageService, number: amountOfBoxes })
    }

  }, [])

  useEffect(() => {
    if (addedOrder) {
      setSend(true);
      dispatch(resetOrder());
      setStart(true);
    }
  }, [addedOrder]); // eslint-disable-line

  const handleChange = (event) => {
    setChecked(event.target.checked);
    console.log(cart)
    if (!checked) {
      // let packageService = products[SERVICES_CATEGORY_ID].find(
      //   (element) => element.entityId === 277527
      // );
      let newCart = [...cart, packageService];
      let newPrice = totalPrice + packageService.price * packageService.number;
      setCart(newCart);
      setTotalPrice(newPrice);
      dispatch(
        modifyLocalForm({
          ...form,
          cart: newCart,
          price: newPrice,
        })
      );
    } else {
      // let packageService = products[SERVICES_CATEGORY_ID].find(
      //   (element) => element.entityId === 277527
      // );
      let newCart = cart.filter((element) => element.entityId !== 277527);
      let newPrice = totalPrice - packageService.price * packageService.number;
      setCart(cart.filter((element) => element.entityId !== 277527));
      setTotalPrice(newPrice);
      dispatch(
        modifyLocalForm({
          ...form,
          cart: newCart,
          price: newPrice,
        })
      );
    }
  };
  const onAddOrder = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else {
      const date = {
        status: "new",
        StoreMerchantId: process.env.REACT_APP_DELIVERY_MERCHANT_ID,
        products:
          form?.cart.map((item) => ({
            id: item.entityId,
            quantity: item.number || 1,
            price: item.price,
          })) || [],
        phone: form?.phone || "",
        firstName: form?.firstName || "",
        name: form?.firstName || "Anton",
        email: form?.email || "",
        address: form?.extraFields?.fromaddress || "",
        productTotal: form?.price || 0,
        price: form?.price || 0,
        vat: 17,
        extraFields: form?.extraFields
          ? {
            ...form.extraFields,
            ordertype: "booking",
          }
          : {},
      };
      if (form?.servicesPrice > 0) {
        date.products.push({
          id: 277524,
          quantity: 1,
          price: form?.servicesPrice,
        });
      }

      dispatch(addOrder(date, "only_delivery"));
    }
    setValidated(true);
  };

  const transformFieldValue = (value) => {
    switch (value) {
      case true:
      case "yes":
        return "יש";
      case false:
      case "no":
        return "אין";
      default:
        return "לא ידוע";
    }
  };

  const galleryArr = [
    {
      img: galleryImg1,
    },
    {
      img: galleryImg2,
    },
    {
      img: galleryImg3,
    },
    {
      img: galleryImg4,
    },
    {
      img: galleryImg5,
    },
    {
      img: galleryImg6,
    },
  ];

  return (
    <div className="transportFewItems">
      {/* <div className="page_banner">
        <img src={bannerImg} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הזמנת הובלה אונליין</h1>
            <p>רק למלא פרטים ולשלוח</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/transportonlineitems" />
            <MainBtn
              text="הזמנה בעזרת נציג"
              link="/transportgetback"
              isLight={true}
            />
          </div>
        </div>
      </div>

      <Pros /> */}

      <div className="servicesDiv">
        <h1 className="homeTitle">פרטי הובלה</h1>
        <div className="splitDiv">
          {/* <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="שירותי הובלות"
              galleryArr={galleryArr}
            />
          </div> */}

          <div className="formSide">
            {send ? (
              <PaymentSuccess
                text1="תודה שבחרתם בנו!"
                text2="העתק הצעת המחיר על תנאי תשלח אליכם למייל"
                text3="נציגנו יצרו עמכם קשר בהקדם להשלמת התהליך"
              />
            ) : (
              <>
                {/*{TODO Привести Extrafields в нормальный вид потом}*/}
                <div className="order-summary-container">
                  <div className="order-personaldetails">
                    <p>
                      <strong>שם מלא:</strong>{" "}
                      {form?.firstName ? form?.firstName : ""}
                    </p>
                    <p>שעת תחילה הובלה: {form?.extraFields?.timemove}</p>
                    <p>תאריך מעבר: {(format(new Date(form?.extraFields?.datemove), "dd-MM-yyyy"))}</p>
                  </div>
                  <div className="present-address">
                    <h5 className="address-title">
                      <strong> כתובת המוצא:</strong>{" "}
                      {form?.extraFields?.fromaddress}
                    </h5>
                    <p> קומה: {form?.extraFields?.fromfloor}</p>
                    <p>
                      {" "}
                      מעלית:{" "}
                      {form?.extraFields?.fromtransporttype
                        ? form?.extraFields?.fromtransporttype
                        : "אין"}{" "}
                    </p>
                    <p>
                      {" "}
                      שביל כניסה חריג:{" "}
                      {
                        // transformFieldValue(
                        form?.extraFields?.fromunusualwalkway
                        // )
                      }
                    </p>
                    <p>
                      {" "}
                      מנוף:{" "}
                      {
                        // transformFieldValue(
                        form?.extraFields?.fromneedforleverage
                          ? form?.extraFields?.fromneedforleverage
                          : "לא"
                        // )
                      }
                    </p>
                  </div>
                  <div className="future-address">
                    <h5 className="address-title">
                      <strong> כתובת היעד:</strong>{" "}
                      {form?.extraFields?.toaddress}
                    </h5>
                    <p> קומה: {form?.extraFields?.tofloor} </p>
                    <p>
                      {" "}
                      מעלית:{" "}
                      {form?.extraFields?.totransporttype
                        ? form?.extraFields?.totransporttype
                        : "אין"}{" "}
                    </p>
                    <p>
                      {" "}
                      שביל כניסה חריג:{" "}
                      {
                        // transformFieldValue(
                        form?.extraFields?.tounusualwalkway
                        // )
                      }
                    </p>
                    <p>
                      {" "}
                      מנוף:{" "}
                      {
                        // transformFieldValue(
                        form?.extraFields?.toneedforleverage
                          ? form?.extraFields?.toneedforleverage
                          : "לא"
                        // )
                      }
                    </p>
                  </div>
                  <div className="chosen-items-list">
                    <strong>פריטים שבחרתי:</strong>
                    <ul>
                      {cart?.filter(i => i.entityId !== 277629 && i.entityId !== 277538).map((item, idx) => {
                        return (
                          <li key={idx} className="li-item">
                            <span>{item.title}</span><span>{item.number ? ' * ' : ''}</span><span>{item.number}</span>
                            {item.p ? " + פירוק" : ""}
                            {item.h ? " + הרכבה" : ""}
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  <div className="contact-btnDiv send">
                    <MainBtn
                      text="הוספת/הסרת פריטים"
                      link="/transportonlineitems"
                    />
                  </div>

                  <strong className="moving-total-price">
                    מחיר הובלה כולל מע''מ: {totalPrice} ₪
                  </strong>
                </div>

                {/* <div className="terms-container"> */}
                <Form
                  // className="formBox"
                  className="terms-container"
                  noValidate
                  validated={validated}
                  onSubmit={onAddOrder}
                >
                  <div className="filter-btn-div">
                    <Form.Group className="mb-3">
                      <p>
                        {packageService.price && (<div className="filter-btn-div">
                          <Form.Check
                            inline
                            reverse
                            onChange={handleChange}
                          // id="addPackage"
                          />
                          <label>הוספת שירותי אריזה ב-{packageService.price * packageService.number} ₪ בלבד</label>
                        </div>)}
                      </p>
                      <Form.Check
                        // disabled={!read}
                        onChange={() => setRead(prev => !prev)}
                        checked={read}
                        inline
                        reverse
                        required
                        feedback="נא לאשר את התקנון"
                        feedbackType="invalid"
                        label={
                          <>
                            {"  קראתי ואני מאשר את "}
                            <span
                              onClick={() => setShow(true)}
                              className="terms"
                            >
                              תקנון ההובלה
                            </span>
                          </>
                        }
                      />
                    </Form.Group>
                  </div>
                  <div
                    className="filter-btn-div send"
                    style={{ ":hover": { cursor: "pointer" } }}
                  >
                    <Button type="submit" className="filter-btn transbtn">
                      <p>מחיר סופי כולל מע"מ: {totalPrice} ₪</p>
                      <h1 className="transportSummaryBtnApprove1">אישור</h1>
                    </Button>
                  </div>
                </Form>
              </>
            )}
          </div>
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton className="ml-0" style={{ width: "100%" }}>
          <Modal.Title>תקנון הובלה</Modal.Title>
        </Modal.Header>
        <Modal.Body>פירוט פירוט...</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
              setRead(true);
            }}
          >
            קראתי
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Reviews />
      <Footer /> */}
    </div>
  );
};

export default TransportSummary;
